import "@/App.css";
import { BrowserRouter, Routes, Route, Outlet } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { AuthProvider } from "./context/AuthContext";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import ProtectedRoute from "./components/ProtectedRoute";
import Home from "./pages/Home";
import Listing from "./pages/Listing";
import PostDetail from "./pages/PostDetail";
import Search from "./pages/Search";
import Login from "./pages/Login";
import Admin from "./pages/Admin";
import Unsubscribe from "./pages/Unsubscribe";
import Contact from "./pages/Contact";
import { Toaster } from "sonner";

function Shell() {
  return (
    <div className="grain flex min-h-screen flex-col bg-[#050505] text-white">
      <Navbar />
      <main className="relative z-10 flex-1">
        <Outlet />
      </main>
      <Footer />
    </div>
  );
}

function App() {
  return (
    <div className="App">
      <HelmetProvider>
        <AuthProvider>
          <BrowserRouter>
            <Routes>
              <Route element={<Shell />}>
                <Route path="/" element={<Home />} />
                <Route path="/articles" element={<Listing type="article" title="Articles" kicker="The Longform" />} />
                <Route path="/news" element={<Listing type="article" title="News" kicker="The Latest" />} />
                <Route path="/podcasts" element={<Listing type="podcast" title="Podcasts" kicker="The Baseline Breakdown Podcast" accent="#E36A53" />} />
                <Route path="/digital" element={<Listing type="digital" title="Digital" kicker="The Screen" accent="#4FB7D7" />} />
                <Route path="/category/:tag" element={<Listing kicker="Category" />} />
                <Route path="/post/:slug" element={<PostDetail />} />
                <Route path="/search" element={<Search />} />
                <Route path="/login" element={<Login />} />
                <Route path="/unsubscribe" element={<Unsubscribe />} />
                <Route path="/contact" element={<Contact />} />
                <Route
                  path="/admin"
                  element={
                    <ProtectedRoute>
                      <Admin />
                    </ProtectedRoute>
                  }
                />
              </Route>
            </Routes>
          </BrowserRouter>
          <Toaster theme="dark" position="top-right" />
        </AuthProvider>
      </HelmetProvider>
    </div>
  );
}

export default App;
